import VulnerabilityTable from "./VulnerabilityTable";

export default VulnerabilityTable;
